<div class="production-db-content" dir="{{languageDir}}">
    <div class="content-top-box">
        <ul class="breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
                    <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
                        (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
                </li>
            </ul>
        </ul>
        <div class="title-row-flex-both-end">
            <h1 class="main-title">{{langObj ? langObj?.AdminDashBoard : ('AdminDashBoard' | translate)}}</h1>
        </div>
    </div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
    <form [formGroup]="AdminDashboardForm">
        <div class="content-top-row content-top-row-order-processing">
            <!-- GROUP -->
            <mat-form-field appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                <!-- <mat-label>Status</mat-label> -->
                <mat-select formControlName="UserGroup1" (selectionChange)="onChangeGroup($event)"
                    placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}" panelClass="testClass"
                    name="Status">
                    <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
                        (filteredReturn)="filteredGroups = $event"></mat-select-filter>
                    <mat-option *ngFor="let group of filteredGroups" [value]="group.EG_Id">
                        {{group.EG_Desc}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                <mat-select formControlName="UserPlant1" (selectionChange)="onChangePlant($event)"
                    placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass"
                    name="Status">
                    <mat-option [value]="">
                        All
                    </mat-option>
                    <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
                        (filteredReturn)="filteredPlants = $event"></mat-select-filter>
                    <mat-option *ngFor="let plant of filteredPlants" [value]="plant.PT_Id">
                        {{plant.PT_Desc}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
    <!-- Card -->
    <div class="menu-card-group">
        <div class="menu-card-item mat-card-height" (click)="showDetails('line')" style="cursor: pointer">
            <p class="title-text">{{langObj ? langObj?.NOTOFLINEINPLANT : ('NOTOFLINEINPLANT' | translate)}}</p>
            <p class="data-text  small-data-text">{{NOTOFLINEINPLANT}}</p>
            <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
                <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
            </div>
        </div>
        <div class="menu-card-item mat-card-height" (click)="showDetails('totalMachine')" style="cursor: pointer">
            <p class="title-text">{{langObj ? langObj?.TOTALNOOFMACHINE : ('TOTALNOOFMACHINE' | translate)}}</p>
            <p class="data-text  small-data-text">{{TOTALNOOFMACHINE}}</p>
            <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
                <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
            </div>
        </div>
        <div class="menu-card-item mat-card-height" (click)="showDetails('connectedMachine')" style="cursor: pointer">
            <p class="title-text">{{langObj ? langObj?.CONNECTEDMACHINE : ('CONNECTEDMACHINE' | translate)}}</p>
            <p class="data-text  small-data-text">{{CONNECTEDMACHINE}}</p>
            <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
                <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
            </div>
        </div>
        <div class="menu-card-item mat-card-height" (click)="showDetails('nonConnectedMachine')"
            style="cursor: pointer">
            <p class="title-text">{{langObj ? langObj?.NONCONNECTEDMACHINE : ('NONCONNECTEDMACHINE' | translate)}}</p>
            <p class="data-text  small-data-text">{{NONCONNECTEDMACHINE}}</p>
            <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
                <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
            </div>
        </div>
    </div>

    <div class="menu-card-group">
        <div class="menu-card-item mat-card-height" (click)="showDetails('noofmodule')" style="cursor: pointer">
            <p class="title-text">{{langObj ? langObj?.NOOFMODULEINPLANT : ('NOOFMODULEINPLANT' | translate)}}</p>
            <p class="data-text  small-data-text">{{NOOFMODULEINPLANT}}</p>
            <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
                <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
            </div>
        </div>
        <div class="menu-card-item mat-card-height" (click)="showDetails('noofusers')" style="cursor: pointer">
            <p class="title-text">{{langObj ? langObj?.NOOFUSERSINPLANT : ('NOOFUSERSINPLANT' | translate)}}</p>
            <p class="data-text  small-data-text">{{NOOFUSERSINPLANT}}</p>
            <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
                <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
            </div>
        </div>
        <div class="menu-card-item mat-card-height" (click)="showDetails('noofuserslast24')" style="cursor: pointer">
            <p class="title-text">{{langObj ? langObj?.NOOFUSERLOGINLAST24 : ('NOOFUSERLOGINLAST24' | translate)}}</p>
            <p class="data-text  small-data-text">{{NOOFUSERLOGINLAST24}}</p>
            <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
                <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
            </div>
        </div>

        <div class="menu-card-item mat-card-height" (click)="showDetails('noofcurrentloggedinusers')"
            style="cursor: pointer">
            <p class="title-text">{{langObj ? langObj?.NOOFCURRENTLOGINUSER : ('NOOFCURRENTLOGINUSER' | translate)}}</p>
            <p class="data-text  small-data-text">{{OTHER}}</p>
            <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
                <img class="img" [src]="menuBlueIconUrl" alt="{{ menuBlueIconUrl }}" />
            </div>
        </div>

    </div>
    <div class="chart-group">
        <div class="chart-items" style="width: 100%;">
            <div class="chart-title">{{langObj ? langObj?.LoginUsersLast24 : ('LoginUsersLast24' | translate)}}</div>
            <div [chart]="chartLoginUserstrends"></div>
        </div>
    </div>

    <!-- Details model code here -->

    <ng-template #displayDetailsModal>
        <div mat-dialog-title>
            <div class="d-flex justify-content-between align-items-center">
                <h2>{{type}}</h2>
                <button mat-mini-fab mat-button mat-dialog-close (click)="closeForm()" color="warn" title="close">
                    <i class="fa fa-times" style="color: #fff;"></i>
                </button>
            </div>
        </div>
        <section>
            <div class="example-button-row">
                <button type="button" class="btn btn-success" (click)="csvExport()" style="margin-top: 30px;"><img
                        src="assets/images/csv-file-format.png"></button>
                <button type="button" class="btn btn-success" (click)="excelExport()"
                    style="margin-top: 30px; margin-left: 10px;"><i class="fa fa-file-excel-o icon-white"
                        aria-hidden="true"></i></button>
            </div>
        </section>
        <mat-dialog-content>
            <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="rowData"
                [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions"
                [pagination]="true" [paginationPageSize]="10">
            </ag-grid-angular>
        </mat-dialog-content>
    </ng-template>
</div>

